<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconDoubleChevronLeft_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="m4.183 8.531 3.116 3.117a.623.623 0 1 0 .882-.881L5.505 8.09 8.18 5.415a.623.623 0 1 0-.882-.882L4.183 7.65a.623.623 0 0 0 0 .881Zm3.636.104 3.116 3.117a.623.623 0 1 0 .882-.881L9.14 8.195l2.676-2.676a.623.623 0 1 0-.882-.882L7.82 7.754a.623.623 0 0 0 0 .881Z"
        clip-rule="evenodd"
    />
</svg>
